import { AxiosRequest } from 'src/lib/axios/Axios';

export type LogOperation = 'insert' | 'update' | 'delete';

type LogFieldValue = string | number | string[] | null | undefined;

export interface PublicationLog {
  publication_log_id: LogFieldValue;
  publication_id: LogFieldValue;
  publication_state_id: LogFieldValue;
  config_values: Record<string, unknown> | Record<string, unknown>[] | null;
  publication_type_id: LogFieldValue;
  relevance: LogFieldValue;
  updated_by: LogFieldValue;
  last_change: LogFieldValue;
  operation: LogFieldValue;
}

const normalizePublicationLogsResponse = (data: unknown): PublicationLog[] => {
  if (!data) return [];
  if (Array.isArray(data)) return data as PublicationLog[];
  if (typeof data === 'object') return [data as PublicationLog];
  return [];
};

export const fetchPublicationLogs = async (
  publication_id: string,
  operation?: LogOperation,
): Promise<PublicationLog[]> => {
  const params: Record<string, string> = { publication_id };
  if (operation) params.operation = operation;

  const { data } = await AxiosRequest.get<PublicationLog[] | PublicationLog>('/publications_logs', { params });
  return normalizePublicationLogsResponse(data);
};
